import { registerComponent, defaultStore } from "helpers";

registerComponent(
  "product-summary-inventory",
  class ProductSummaryInventory extends HTMLElement {
    connectedCallback() {
      this.myStoreLocation = this.getStoreData();
      if (this.myStoreLocation) {
        const { name: locationName } = this.myStoreLocation;
        const handle = this.handleize(locationName);
        this.showLocationDetails(handle);
      }
    }

    /**
     * Show location details for preferred location.
     */
    showLocationDetails(handle) {
      const wrapper = this.querySelector(`[data-location-handle="${handle}"]`);
      if (wrapper) {
        const { locationStock: stockData, pickupOnly: pickupData } =
          wrapper.dataset;
        const locationStock = parseInt(stockData, 10);
        const pickupOnly = pickupData === "true";
        const toggleOn = new URLSearchParams(window.location.search).has(
          "filter.v.m.wyatt.availability",
        );

        if (pickupOnly && !toggleOn) {
          return;
        }

        this.querySelector("[data-pickup-only-default]")?.classList.add(
          "hidden",
        );

        if (!pickupOnly && locationStock <= 0) {
          this.displayOnlineOnly();
        } else {
          wrapper.classList.remove("hidden");
        }
      }
    }

    handleize(string) {
      return string.toLowerCase().replace(/ /g, "-");
    }

    /**
     * Selects 'company-wide-stock' location wrapper for display.
     */
    displayOnlineOnly() {
      const onlineStore = "company-wide-stock";
      const onlineOnlyWrapper = this.querySelector(
        `[data-location-handle="${onlineStore}"]`,
      );
      if (onlineOnlyWrapper) {
        const { locationStock: stockData } = onlineOnlyWrapper.dataset;
        const inventory = parseInt(stockData, 10);
        if (inventory > 0) {
          onlineOnlyWrapper.classList.remove("hidden");
        }
      }
    }

    getStoreData() {
      try {
        return JSON.parse(window.localStorage.getItem("storeLocation"));
      } catch (error) {
        console.error(error);
        return null;
      }
    }
  },
);
